import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { classCombine } from 'tradevan-ui/consts';
import EditForm from './component/EditForm';
import EditFormRows, { IcfFormRow } from './component/EditFormRows';

export interface QueryGridProps {
  /** className for EditForm  */
  className?: string;
  /** 隱藏標題上必填符號 */
  hideRequiredSign?: boolean;
  /** 主欄位列 */
  rows: IcfFormRow[];
  /** 折疊欄位列 */
  collapseRows?: IcfFormRow[];
}

/** edit-form 元件組(包括折疊區塊) */
const QueryGrid = (props: QueryGridProps) => {
  const { className, hideRequiredSign, rows, collapseRows = [] } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <EditForm className={className}>
        {/* 主欄位列 */}
        <EditFormRows {...{ hideRequiredSign, rows }} />
        {/* 折疊欄位列 */}
        {!!collapseRows.length && (
          <Collapse in={open}>
            <div>
              <EditFormRows
                hideRequiredSign={hideRequiredSign}
                rows={collapseRows}
              />
            </div>
          </Collapse>
        )}
      </EditForm>
      {/* 折疊按鈕 */}
      {!!collapseRows.length && (
        <button
          type="button"
          className={classCombine(
            'btn',
            'btn-sm',
            'btn-collapse-toggle',
            !open && 'collapsed',
          )}
          onClick={() => setOpen((prev) => !prev)}
        >
          <i />
          <span>進階搜尋</span>
        </button>
      )}
    </>
  );
};

export default QueryGrid;
